/*
 * CUSTOM (Schuhbeck): collections list page — mobile show-more.
 * Companion to sections/main-list-collections.liquid. On connect it truncates
 * the grid to the first 6 cards (mobile-only via CSS) and reveals the
 * show-more button; without JS all cards simply render.
 * The limit of 6 is mirrored by :nth-child(n+7) in
 * component-collection-item-custom.css — keep the two in sync.
 */

if ( typeof CollectionListMore !== 'function' ) {

	class CollectionListMore extends HTMLElement {

		connectedCallback(){

			this._grid = this.querySelector('[data-js-collection-grid]');
			this._button = this.querySelector('[data-js-collection-more]');
			if ( ! this._grid || ! this._button ) return;

			if ( this._grid.querySelectorAll('.collection-card').length > 6 ) {
				this._grid.classList.add('is-truncated');
				this._button.hidden = false;
				this._button.addEventListener('click', ()=>{
					this._grid.classList.remove('is-truncated');
					this._button.hidden = true;
				});
			}

		}

	}

	customElements.define('collection-list-more', CollectionListMore);

}
